<script setup lang="ts">
import { useUiStore } from "@/stores/ui.ts";
import { storeToRefs } from "pinia";
import { ThemeLoading } from "@/ui-components";

const uiStore = useUiStore();
const { isLoading } = storeToRefs(uiStore);
</script>
<template><ThemeLoading v-if="isLoading" /></template>
